import { atom, type WritableAtom } from 'nanostores';

export interface SearchState {
  isOpen: boolean;
  query: string;
}

export class SearchStore {
  isOpen: WritableAtom<boolean> = import.meta.hot?.data.searchIsOpen ?? atom(false);
  query: WritableAtom<string> = import.meta.hot?.data.searchQuery ?? atom('');

  constructor() {
    if (import.meta.hot) {
      import.meta.hot.data.searchIsOpen = this.isOpen;
      import.meta.hot.data.searchQuery = this.query;
    }
  }

  toggleSearch(show?: boolean) {
    const newState = show !== undefined ? show : !this.isOpen.get();
    this.isOpen.set(newState);
    
    // Note: We don't clear search state when toggling tabs anymore
    // Search state should persist when switching between Explorer/Search tabs
    // Only clear when explicitly requested via clearSearch()
  }

  clearSearch() {
    // Method to explicitly clear search state
    this.query.set('');
  }

  setQuery(query: string) {
    this.query.set(query);
  }

  getState(): SearchState {
    return {
      isOpen: this.isOpen.get(),
      query: this.query.get(),
    };
  }
}

export const searchStore = new SearchStore();
